module.exports = "<footer class=\"footer\">\n  <div class=\"container\">\n      <span class=\"text-muted\">All Rights Reserved</span>\n  </div>\n\n</footer>"